import axios from "axios";
import axios2 from "@/axios";
import moment from "moment";
import store from "@/store";

const state = {
  selectedTrolly: 0,
  trollys: [],

  orderBeingPaidFor: null,
};

const getters = {
  retrieveOrder: (state) => {
    return state;
  },

  retrieveSelectedTrolly: (state) => {
    return state.selectedTrolly;
  },

  retrieveAllTrollys: (state) => {
    return state.trollys;
  },

  retrieveHasMultipleTrollys: (state) => {
    if (state.trollys.length > 1) {
      return true;
    }
    return false;
  },

  // retrieveCurrentTrolly: (state) => {
  //   let trolly = false;

  //   if (state.trollys && state.trollys.length > 0) {
  //     state.trollys.forEach((item) => {
  //       console.log("-- Comparing Our Trollies to the ID we want");
  //       console.log(item.id);
  //       console.log(state.selectedTrolly);

  //       if (item.id == state.selectedTrolly) {
  //         trolly = item;

  //         // trolly = state.trollys[state.selectedTrolly];

  //         trolly.order_date_display = moment(trolly.order_date).format(
  //           "dddd, Do MMMM YYYY"
  //         );

  //         let trollyValue = 0;
  //         let totalQty = 0;

  //         Object.keys(trolly.trolly_items).forEach(function(key) {
  //           let itemValue = 0;
  //           totalQty += parseFloat(trolly.trolly_items[key].qty);

  //           switch (trolly.trolly_items[key].qty_type) {
  //             case "B":
  //               itemValue =
  //                 trolly.trolly_items[key].box_price *
  //                 parseFloat(trolly.trolly_items[key].qty);

  //               trolly.trolly_items[key].itemType = "Box";
  //               trolly.trolly_items[key].itemPrice = parseFloat(
  //                 trolly.trolly_items[key].box_price
  //               ).toFixed(2);
  //               trolly.trolly_items[key].itemValue = parseFloat(
  //                 itemValue
  //               ).toFixed(2);
  //               trollyValue += itemValue;
  //               break;
  //             case "K":
  //               itemValue =
  //                 trolly.trolly_items[key].kilo_price *
  //                 parseFloat(trolly.trolly_items[key].qty);

  //               trolly.trolly_items[key].itemType = "Kilo";
  //               trolly.trolly_items[key].itemPrice = parseFloat(
  //                 trolly.trolly_items[key].kilo_price
  //               ).toFixed(2);
  //               trolly.trolly_items[key].itemValue = parseFloat(
  //                 itemValue
  //               ).toFixed(2);
  //               trollyValue += itemValue;
  //               break;
  //             case "E":
  //               itemValue =
  //                 trolly.trolly_items[key].each_price *
  //                 parseFloat(trolly.trolly_items[key].qty);

  //               trolly.trolly_items[key].itemType = "Each";
  //               trolly.trolly_items[key].itemPrice = parseFloat(
  //                 trolly.trolly_items[key].each_price
  //               ).toFixed(2);
  //               trolly.trolly_items[key].itemValue = parseFloat(
  //                 itemValue
  //               ).toFixed(2);
  //               trollyValue += itemValue;
  //               break;
  //           }
  //         });

  //         trollyValue = parseFloat(trollyValue).toFixed(2);
  //         trolly.totalValue = trollyValue;
  //         trolly.totalQty = totalQty;
  //         trolly.totalItems = Object.keys(trolly.trolly_items).length;
  //       }
  //     });
  //   }

  //   return trolly;
  // },

  retrieveCurrentTrolly: (state) => {
    let trolly = false;

    if (state.trollys && state.trollys.length > 0) {
      state.trollys.forEach((item) => {
        console.log("-- Comparing Our Trollies to the ID we want");
        console.log(item.id);
        console.log(state.selectedTrolly);

        if (item.id == state.selectedTrolly) {
          trolly = item;

          // trolly = state.trollys[state.selectedTrolly];

          trolly.order_date_display = moment(trolly.order_date).format(
            "dddd, Do MMMM YYYY"
          );

          let trollyValue = 0;
          let totalQty = 0;
          let totalItems = 0;
          let trollyVAT = 0;

          Object.keys(trolly.trolly_items).forEach(function(key) {
            //returns dist no as keys for the trolly
            let distValue = 0;
            let distQty = 0;
            let distItems = 0;

            //totalQty += parseFloat(trolly.trolly_items[key].qty);
            totalItems += Object.keys(trolly.trolly_items[key].items).length;
            distItems += Object.keys(trolly.trolly_items[key].items).length;

            Object.keys(trolly.trolly_items[key].items).forEach(function(prod) {
              let itemValue = 0;

              totalQty += parseFloat(trolly.trolly_items[key].items[prod].qty);
              distQty += parseFloat(trolly.trolly_items[key].items[prod].qty);

              trollyVAT += trolly.trolly_items[key].items[prod].item_vat;

              switch (trolly.trolly_items[key].items[prod].qty_type) {
                case "B":
                  itemValue =
                    trolly.trolly_items[key].items[prod].box_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Box";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].box_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
                case "K":
                  itemValue =
                    trolly.trolly_items[key].items[prod].kilo_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Kilo";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].kilo_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
                case "E":
                  itemValue =
                    trolly.trolly_items[key].items[prod].each_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Each";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].each_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
              }
            });
            //Set Dist Values
            distValue = parseFloat(distValue).toFixed(2);

            trolly.trolly_items[key].distValue = distValue;
            trolly.trolly_items[key].distQty = distQty;
            trolly.trolly_items[key].distItems = distItems;
          });

          trollyValue = parseFloat(trollyValue).toFixed(2);

          trolly.totalValue = trollyValue;
          trolly.totalQty = totalQty;
          trolly.totalItems = totalItems;
        }
      });
    }

    return trolly;
  },

  retrieveCurrentTrollyDiscountEnabled: (state) => {
    let value = false;

    if (state.trollys && state.trollys.length > 0) {
      state.trollys.forEach((item) => {
        console.log("-- Comparing Our Trollies to the ID we want");
        console.log(item.id);
        console.log(state.selectedTrolly);

        if (item.id == state.selectedTrolly) {
          let selectedTrolly = item;
          value =
            selectedTrolly.order_discount.discount_enabled == "1"
              ? true
              : false;
        }
      });
    }

    return value;
  },

  retrieveCurrentTrollyDiscountTotal: (state) => {
    let discountValue = 0;

    if (state.trollys && state.trollys.length > 0) {
      state.trollys.forEach((item) => {
        console.log("-- Comparing Our Trollies to the ID we want");
        console.log(item.id);
        console.log(state.selectedTrolly);

        if (item.id == state.selectedTrolly) {
          let selectedTrolly = item;

          discountValue = parseFloat(
            selectedTrolly.order_discount.discount_value
          ).toFixed(2);
        }
      });
    }

    return discountValue;
  },

  retrieveCurrentTrollyDiscountVAT: (state) => {
    let discountValue = 0;

    if (state.trollys && state.trollys.length > 0) {
      state.trollys.forEach((item) => {
        console.log("-- Comparing Our Trollies to the ID we want");
        console.log(item.id);
        console.log(state.selectedTrolly);

        if (item.id == state.selectedTrolly) {
          let selectedTrolly = item;

          discountValue = parseFloat(
            selectedTrolly.order_discount.discount_vat
          ).toFixed(2);
        }
      });
    }

    return discountValue;
  },

  retrieveCurrentTrollyDiscountAmount: (state) => {
    let discountValue = 0;

    if (state.trollys && state.trollys.length > 0) {
      state.trollys.forEach((item) => {
        console.log("-- Comparing Our Trollies to the ID we want");
        console.log(item.id);
        console.log(state.selectedTrolly);

        if (item.id == state.selectedTrolly) {
          let selectedTrolly = item;

          discountValue = parseFloat(
            selectedTrolly.order_discount.discount_ex_vat
          ).toFixed(2);
        }
      });
    }

    return discountValue;
  },

  retrieveOrderBeingPaidFor: (state) => {
    if (state.orderBeingPaidFor) {
      return state.orderBeingPaidFor;
    }
  },

  retrieveTrollyItemsOutOfStock : (state,getters) => {
    const outOfStockItems = []
    if (getters.retrieveCurrentTrolly.trolly_items && getters.retrieveStockConfig) {
      let trollyItems = getters.retrieveCurrentTrolly.trolly_items
      Object.keys(trollyItems).forEach((key)=>{
          trollyItems[key].items.filter((item)=> {
            return item.out_of_stock == 1;
          }).forEach((prod)=>{
            outOfStockItems.push({id:prod.prod_no})
          })
      })     
    }
    return outOfStockItems;
  },
  
  retrieveTrollyRequiresAttentionFlag:(state,getters) =>{
    let requiresAttention = false
    if (getters.retrieveCurrentTrolly.trolly_items) {
      let trollyItems = getters.retrieveCurrentTrolly.trolly_items
      if(Object.keys(trollyItems).length > 0) {
        if (getters.retrieveCurrentTrolly.valid == false && getters.retrieveUser.username != "anonuser" ) {
          requiresAttention =true 
        }
      }
    }
    return requiresAttention;
  }
};

const actions = {
  clearOrder({ commit }) {
    //Revert our order state back to it's default
    const clearOrderResponse = commit("setOrder", {
      orderDate: null,
      custRef: "",
      specialInstructions: "",
      id: null,
    });
    return clearOrderResponse;
  },

  async getTrollys({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo: this.getters.retrieveSelectedCustomer,
      template: 0,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2
      .post("trolly/get-trollys", params)
      .catch((er) => {
        return false;
      });

    if (response.data.success == true) {
      //if there's only 1 trolly let's automatically select it
      if (response.data.trolly.length == 1) {
        commit("setSelectedTrolly", response.data.trolly[0].id);
      }

      commit("setTrollies", response.data);

      return response.data.success;
    } else {
      response.data.success;
    }
  },

  async setGuestTrolly({ commit }, payload) {
    commit("setTrollies", payload);
  },

  async setSelectedTrolly({ commit }, id) {
    commit("setSelectedTrolly", id);
  },

  async createNewTrolly({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      orderDate: orderInfo.orderDate,
      custRef: orderInfo.custRef,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios
      .post("create-new-trolly", params)
      .catch((er) => {
        return false;
      });

    if (response.data.success == true) {
      return response.data;
    } else {
      return false;
    }
  },

  async deleteTrolly({ commit }, trollyID) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: trollyID,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("del-trolly", params).catch((er) => {
      return false;
    });

    if (response.data.success == true) {
      return response.data.success;
    } else {
      return false;
    }
  },

  async updateTrollyOrderDate({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: this.getters.retrieveCurrentTrolly.id,
      orderDate: orderInfo.orderDate,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios
      .post("trolly-update-order-date", params)
      .catch((er) => {
        return false;
      });

    if (response.data.success == true) {
      return response.data.success;
    } else {
      return response.data.success;
    }
  },

  async updateTrollyCustRef({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: this.getters.retrieveCurrentTrolly.id,
      custRef: orderInfo.custRef,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios
      .post("trolly-update-cust-ref", params)
      .catch((er) => {
        return false;
      });

    if (response.data.success == true) {
      return response.data.success;
    } else {
      return response.data.success;
    }
  },

  async applyTrollyDiscountCode({ commit }, discount_code) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: this.getters.retrieveCurrentTrolly.id,
      discount_code: discount_code,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2
      .post("trolly/apply-trolly-discount", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data) {
        if (response.data.success) {
          await store.dispatch("getTrollys");
        } else {
          store.dispatch("setSnackbar", {
            color: "error",
            text: response.data.messages[0],
          });
        }

        return response.data.success;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  async applyTrollyDiscountAmount({ commit }, amount) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: this.getters.retrieveCurrentTrolly.id,
      discount_amount: amount,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2
      .post("trolly/apply-trolly-discount-amount", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data) {
        if (response.data.success) {
          await store.dispatch("getTrollys");
        } else {
          store.dispatch("setSnackbar", {
            color: "error",
            text: response.data.messages[0],
          });
        }

        return response.data.success;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  async cloneTrolly({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: orderInfo.trollyId,
      orderDate: null,
      custRef: null,
      template: orderInfo.template,
      name: orderInfo.name,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("trolly/clone-trolly", params);

    if (response.data.success == true) {
      return response.data;
    } else {
      return false;
    }
  },

  async reincarnateOrder({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      tdId: orderInfo.tdId,
      orderDate: orderInfo.orderDate,
      custRef: orderInfo.custRef,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("reincarnate-order", params);

    if (response.data.success == true) {
      return response.data;
    } else {
      return false;
    }
  },

  orderBeingPaidForAction({ commit }, orderInfo) {
    commit("setOrderBeingPaidFor", orderInfo);
    //console.log(orderInfo)
  },

  clearOrderBeingPaidFor({ commit }) {
    commit("setOrderBeingPaidFor", null);
  },

  clearTrollys({ commit }) {
    commit("setTrollies", { trolly: [] });
  },
};

const mutations = {
  setTrollies: (state, value) => (state.trollys = value.trolly),
  setSelectedTrolly: (state, value) => (state.selectedTrolly = value),
  setTrollyInvalid: (state, value) =>
    state.trollys.forEach((troly) => {
      if (troly.id == value) {
        troly.valid = false;
        troly.delivery_date_valid.valid = false;
      }
    }),

  setOrderBeingPaidFor: (state, orderDetails) =>
    (state.orderBeingPaidFor = orderDetails),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
